"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TitleEscrowFactory", {
  enumerable: true,
  get: function get() {
    return _contracts.TitleEscrow__factory;
  }
});
Object.defineProperty(exports, "TitleEscrowCreatorFactory", {
  enumerable: true,
  get: function get() {
    return _contracts.TitleEscrowCreator__factory;
  }
});
Object.defineProperty(exports, "TradeTrustErc721Factory", {
  enumerable: true,
  get: function get() {
    return _contracts.TradeTrustERC721__factory;
  }
});
Object.defineProperty(exports, "getTitleEscrowCreatorAddress", {
  enumerable: true,
  get: function get() {
    return _config.getTitleEscrowCreatorAddress;
  }
});

var _contracts = require("./contracts");

var _config = require("./config");